module.exports = __webpack_public_path__ + "static/categories-cb38c42c77b6aec9b04a127e39b88b20.svg";